"use client";

import { motion, AnimatePresence } from "motion/react";
import { useEffect, useState } from "react";

interface LMSItem {
    name: string;
    logo: string;
}

const lmsItems: LMSItem[] = [
    { name: "Moodle", logo: "/lms/moodle-h.png" },
    { name: "Canvas", logo: "/lms/canvas-h.png" },
    { name: "Blackboard", logo: "/lms/blackboard-h.png" },
    { name: "Google Classroom", logo: "/lms/classroom-h.png" },
    { name: "Microsoft Teams", logo: "/lms/teams-h.png" }
];

export function AnimatedLMSText() {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((current) => (current + 1) % lmsItems.length);
        }, 3000); // Change every 3 seconds

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="inline-flex items-center">
            <AnimatePresence mode="wait">
                <motion.div
                    key={currentIndex}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.5 }}
                    className="flex items-center space-x-2"
                >
                    <img 
                        src={lmsItems[currentIndex].logo} 
                        alt={lmsItems[currentIndex].name}
                        className="h-10 sm:h-14 md:h-16 lg:h-20 w-auto object-contain"
                    />
                </motion.div>
            </AnimatePresence>
        </div>
    );
}
